export const DESKTOP_BANNER =
  "https://imgd.aeplcdn.com/0x0/cw/static/landing-banners/electric-car-banner-d-v1.jpg?v=1";
export const MSITE_BANNER =
  "https://imgd.aeplcdn.com/0x0/cw/static/landing-banners/electric-car-banner-m.jpg";
export const ELECTRIC_CARS_PAGE = "/new/electric-cars/";
export const PAGE_API = "/api/electriccars/";
export const EXPERTREVIEW_ENDPOINT = "/expert-reviews/";
export const FEATURES_ENDPOINT = "/features/";
export const NEWS_ENDPOINT = "/news/";

export const EXPERTREVIEW_ENDPOINT_MSITE = "/expert-reviews/";
export const FEATURES_ENDPOINT_MSITE = "/features/";
export const NEWS_ENDPOINT_MSITE = "/news/";

export const VIEW_ALL_EXPERTREVIEWS = "View All Expert Reviews";
export const VIEW_ALL_NEWS = "View All News";
export const VIEW_ALL_FEATURES = "View All Featured Stories";

export const BREADCRUMB_ENTITY = [
  {
    title: "Home",
    text: "Home",
    url: "/",
  },
  { title: " CarWale New Cars", text: "New Cars", url: "/new/" },
  {
    text: "Electric Cars",
  },
];
